<template>
    <modal :open="open" title="Delete Article" @close="$emit('close')">


        <h3><span v-t="'Are you sure you want to delete the article'"></span> '{{article.title}}'?</h3>

        <p v-t="'It will be permanently deleted and removed from all pages.'"></p>

        <div class="modal__done">
            <button @click="deleteArticle()" :disabled="saving"><span v-if="!saving" v-t="'Delete Article'"></span><span v-if="saving"><i class="material-icons">sync</i> Deleting</span></button>
            <a class="button--close" @click="$emit('close')" v-t="'Cancel'"></a>
        </div>
    </modal>
</template>

<script>
    import Modal from '@/components/Modal.vue'

    export default {
        props: ['open', 'article'],
        components: {
            Modal
        },
        data () {
            return {
                saving: null
            }
        },
        methods: {
            deleteArticle () {
                if (this.article){
                    this.saving = true
                    this.$http.delete('/articles/'+this.article.id+'/').then(data => {
                        this.saving = false
                        this.$emit('close')
                        this.$store.dispatch('messages/success', 'Article Deleted')
                        this.$nextTick(() => {
                            this.$router.push({ name: 'articles' })
                          })
                    }).catch(errors => {
                        this.saving = null
                        if(errors && errors.response && errors.response.data){
                            this.errors = errors.response.data
                        }
                    })
                }
            }
        }
    }
</script>